
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19.875 20.099"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_44919","data-name":"Group 44919","transform":"translate(.755 .765)"}},[_c('g',{attrs:{"id":"Group_32274","data-name":"Group 32274"}},[_c('path',{attrs:{"id":"Path_20893","data-name":"Path 20893","d":"M3.37 15.812h1.906a4.218 4.218 0 007.914 0H15m2.881-.489a1.663 1.663 0 01-1.182.489H1.667a1.716 1.716 0 01-.357-.038 1.665 1.665 0 01-1.271-1.983v-.007l1.791-8.06a7.3 7.3 0 0114.159-.368l2.348 8.458a1.688 1.688 0 01.032.328 1.666 1.666 0 01-.486 1.181z","fill":"none","stroke":"#7c76fa","stroke-miterlimit":"10","stroke-width":"1.5"}})])])])
          )
        }
      }
    